module.exports = __webpack_public_path__ + "static/media/vuelaverde.761aea8f.jpg";